import { render, staticRenderFns } from "./SearchCoordenadaClaro.vue?vue&type=template&id=a2a2e554"
import script from "./SearchCoordenadaClaro.vue?vue&type=script&lang=js"
export * from "./SearchCoordenadaClaro.vue?vue&type=script&lang=js"
import style0 from "./SearchCoordenadaClaro.vue?vue&type=style&index=0&id=a2a2e554&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports